import * as yup from "yup";

const queryParamsSchema = yup.object().shape({
  prefill_token: yup.string().optional(),
});

export type QueryParams = yup.InferType<typeof queryParamsSchema>;

export const validateProfileFieldPrefillSearchParams = (
  search: Record<string, unknown>,
): QueryParams => queryParamsSchema.cast(search, { stripUnknown: true });

export interface ProfileFieldPrefillData {
  choices?: string[];
  choices_attributes?: Array<{ value: string }>;
  community_view?: boolean;
  description?: string;
  edit_profile?: boolean;
  field_type?: string;
  hidden?: boolean;
  key?: string;
  label?: string;
  number_custom_position?: string;
  number_custom_text?: string;
  number_decimal?: number;
  number_format?: string;
  number_options_attributes?: {
    format?: string;
    decimal?: number;
    text?: string;
    position?: string;
  };
  placeholder?: string;
  profile_view?: boolean;
  required?: boolean;
  signup?: boolean;
}

const transformChoices = (
  prefillData: ProfileFieldPrefillData,
  transformed: Record<string, unknown>,
) => {
  if (prefillData.choices && Array.isArray(prefillData.choices)) {
    transformed.choices_attributes = prefillData.choices.map(choice => ({
      value: choice,
    }));
    delete transformed.choices;
  }
};

const transformNumberOptions = (
  prefillData: ProfileFieldPrefillData,
  transformed: Record<string, unknown>,
) => {
  if (
    prefillData.number_format ||
    prefillData.number_decimal !== undefined ||
    prefillData.number_custom_text ||
    prefillData.number_custom_position
  ) {
    transformed.number_options_attributes = {
      format: prefillData.number_format || "number",
      decimal:
        prefillData.number_decimal !== undefined
          ? prefillData.number_decimal
          : 0,
      text: prefillData.number_custom_text || "",
      position: prefillData.number_custom_position || "right",
    };
    delete transformed.number_format;
    delete transformed.number_decimal;
    delete transformed.number_custom_text;
    delete transformed.number_custom_position;
  }
};

const transformPagesAttributes = (
  prefillData: ProfileFieldPrefillData,
  transformed: Record<string, unknown>,
) => {
  if (
    prefillData.signup !== undefined ||
    prefillData.edit_profile !== undefined ||
    prefillData.profile_view !== undefined ||
    prefillData.community_view !== undefined
  ) {
    transformed.pages_attributes = [
      { visible: prefillData.signup !== undefined ? prefillData.signup : true },
      {
        visible:
          prefillData.edit_profile !== undefined
            ? prefillData.edit_profile
            : true,
      },
      {
        visible:
          prefillData.profile_view !== undefined
            ? prefillData.profile_view
            : true,
      },
      {
        visible:
          prefillData.community_view !== undefined
            ? prefillData.community_view
            : true,
      },
    ];
    delete transformed.signup;
    delete transformed.edit_profile;
    delete transformed.profile_view;
    delete transformed.community_view;
  }
};

export const transformPrefillDataForForm = (
  prefillData?: ProfileFieldPrefillData,
): Record<string, unknown> => {
  if (!prefillData) {
    return {};
  }

  const transformed: Record<string, unknown> = { ...prefillData };

  transformChoices(prefillData, transformed);
  transformNumberOptions(prefillData, transformed);
  transformPagesAttributes(prefillData, transformed);

  return transformed;
};
